import { defineStore } from 'pinia';

export const useRegistrationDocumentTypesStore = defineStore('registration_document_types', {
	state: () => ({
		registration_document_types: null
	}),
	getters: {
		getRegistrationDocumentTypes(state) {
			return state.registration_document_types;
		},
		getRegistrationDocumentTypeById: (state) => (id) => {
			let document = state.registration_document_types.find(document_type => document_type.id === id);
			if (document) return document.type;
			return null;
		}
	},
	actions: {
		setRegistrationDocumentType(data) {
			this.registration_document_types = data;
		}
	},
})